import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import Middlewares from '../middlewares';
import RootReducer from '../reducers';
// import I18n from '../i18n';
import Sagas from '../sagas';

export const history = createHistory();
const sagaMiddleware = createSagaMiddleware();
const initialState = {};

function Store() {
  const middlewaresArr = [routerMiddleware(history)];
  if (module.hot) {
    middlewaresArr.push(createLogger());
  }
  const store = createStore(
    RootReducer,
    initialState,
    compose(applyMiddleware(...middlewaresArr, sagaMiddleware, ...Middlewares))
  );
  sagaMiddleware.run(Sagas);
  return store;
}

const store = Store();

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js